export interface CountDownLabels {
  d: string;
  h: string;
  m: string;
  s: string;
}

export class CountDownUtils {

  public static generateCountDown($countdownEl: HTMLElement, date: string | Date, texts?: CountDownLabels, callbackEnd?: Function, callbackParams?: any): number {

    texts = {
      d: 'days',
      h: 'hours',
      m: 'minutes',
      s: 'seconds',
      ...texts,
    };

    /**
     * Set the date we're counting down to
     */
    const countDownDate = new Date(date).getTime();

    /**
     * Update the count-down every 1 second
     */
    const loopCountdown = window.setInterval(() => {

      // Get today's date and time
      const now = new Date().getTime();

      // Find the distance between now and the count down date
      const distance = countDownDate - now;

      // If the count down is finished, write some text
      if (distance <= 0) {
        clearInterval(loopCountdown);
        if (callbackEnd) {
          callbackEnd(callbackParams);
        }

        // return;
      }

      // Time calculations for days, hours, minutes and seconds
      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (distance <= 0) {
        days = 0;
        hours = 0;
        minutes = 0;
        seconds = 0;
      }

      $countdownEl.innerHTML = `
                      <div class="amg-countdown__item amg-countdown__item--days ${days === 0 ? 'amg-countdown__item--completed': ''}"><span class="amg-countdown__number">${days < 10 ? '0': ''}${days}</span><span class="amg-countdown__label">${texts.d}</span></div>
                      <div class="amg-countdown__item amg-countdown__item--hours ${days === 0 && hours === 0 ? 'amg-countdown__item--completed': ''}"><span class="amg-countdown__number">${hours < 10 ? '0': ''}${hours}</span><span class="amg-countdown__label">${texts.h}</span></div>
                      <div class="amg-countdown__item amg-countdown__item--minutes ${days === 0 && hours === 0 && minutes === 0 ? 'amg-countdown__item--completed': ''}"><span class="amg-countdown__number">${minutes < 10 ? '0': ''}${minutes}</span><span class="amg-countdown__label">${texts.m}</span></div>
                      <div class="amg-countdown__item amg-countdown__item--seconds ${days === 0 && hours === 0 && minutes === 0 && seconds === 0 ? 'amg-countdown__item--completed': ''}"><span class="amg-countdown__number">${seconds < 10 ? '0': ''}${seconds}</span><span class="amg-countdown__label">${texts.s}</span></div>`;
    }, 1000);

    return loopCountdown;
  }
}
